import to from 'await-to-js';
import axios from 'axios';
import { useCallback } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { HoneyloveWindow } from '../../models/HoneyloveWindow';
import { environmentContextState, smsPhoneStatusState } from '../../recoil/atoms';

declare const window: HoneyloveWindow;

const usePhoneSubscribe = (customListId?: string): ((payload: { phone: string }) => Promise<void>) => {
  const environmentContext = useRecoilValue(environmentContextState);
  const listId = customListId ?? environmentContext.smsListId; // TODO you are here
  const setResponse = useSetRecoilState(smsPhoneStatusState);

  return useCallback(
    async (payload: { phone: string }) => {
      const url = `https://${environmentContext.dataApiDomain}/api/sms?phone_number=${encodeURIComponent(payload.phone)}&list_id=${encodeURIComponent(listId)}`;

      const [err, result] = await to(axios.post<{ success: boolean }>(url, '', {}));
      if (err && typeof window !== 'undefined') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const message: string | undefined = (err as any).response?.data;
        setResponse({ success: false, message: message ?? 'An error occurred. Please try again.' });
        window.Sentry?.captureException(err);
      }
      result && setResponse({ success: true });
    },
    [environmentContext.dataApiDomain, listId, setResponse],
  );
};

export default usePhoneSubscribe;
